import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  nextButton: {
    minWidth: '96px',
  },
  fillButton: {
    minWidth: '220px !important',
  },
  projectInfoContainer: {
    maxWidth: '675px',
    flexDirection: 'column',
    marginBottom: '32px',
  },
  label: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT2,
    marginBottom: '8px',
  },
  valueText: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '24px',
    whiteSpace: 'pre-line',
  },
  companyFormContainer: {
    marginBottom: '24px',
  },
  companyNameText: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: 0,
    color: STYLE.COLOR.TEXT2,
    marginBottom: '24px',
    marginTop: '24px',
  },
  consentFormLegal: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '8px',
  },
  projectAcceptedContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  projectAcceptedText: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: STYLE.COLOR.SUCCESS,
    marginLeft: '12px',
  },
  skippedFieldsMessage: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '22px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
  },
  highlightedField: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '22px',
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },
  termsAndConditionsContent: {
    whiteSpace: 'pre-wrap',
  },
  headerSpacer: {
    marginBottom: '52px',
  },
  badgeModalParagraph: {
    marginBottom: '16px',
  },
  badgeModalList: {
    margin: '0 0 16px 0',
    paddingLeft: '20px',
  },
  badgeModalListItem: {
    marginBottom: '8px',
  },
  sectionContainer: {
    border: `1px solid ${STYLE.COLOR.CARD_BORDER}`,
    borderRadius: '16px',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 24px',
    cursor: 'pointer',
    userSelect: 'none' as const,
  },
  sectionTitle: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '140%',
    letterSpacing: 0,
    color: STYLE.COLOR.TEXT1,
  },
  sectionHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  sectionEntryCount: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: 0,
    color: STYLE.COLOR.TEXT2,
  },
  sectionChevron: {
    color: STYLE.COLOR.TEXT1,
  },
  sectionContent: {
    padding: '0 24px 24px',
  },
  sectionSpacer: {
    height: '20px',
  },
  sectionGap: {
    height: '24px',
  },
  storedFieldInput: {
    '& .Mui-disabled': {
      opacity: '0.8 !important',
      cursor: 'default !important',
    },
  },
  storedFieldLabel: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: 0,
    color: STYLE.COLOR.TEXT2,
    marginBottom: '4px',
  },
  storedFieldValue: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: 0,
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word' as const,
    overflowWrap: 'anywhere' as const,
  },
  storedFieldImageRow: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: '12px',
    marginTop: '4px',
  },
  storedFieldImage: {
    width: 148,
    height: 148,
    borderRadius: 16,
    objectFit: 'cover' as const,
    display: 'block',
  },
}));
